import useWindowSize from 'shared/hooks/useWindowSize';
import { BREAKPOINTS } from '../utils/constants';

export default function useResponsive() {
    const { width } = useWindowSize();
    return {
        isMobile: width < BREAKPOINTS.mobile,
        isTablet: width < BREAKPOINTS.tablet,
    };
}
